module.exports = __webpack_public_path__ + "static/media/refresh.361d8b80.svg";